<div class="row">
	<app-loading-modal
		[visible]="isLoading"
		[message]="'Generando reporte'"
	></app-loading-modal>
	<app-client-modal
		[visible]="showClientModal"
		[selectedClientId]="selectedClient"
		[clientes]="clientes"
		(onAccept)="handleClientSelection($event)"
		(onCancel)="showClientModal = false"
	>
	</app-client-modal>
	<div class="col-lg-12">
		<div class="card">
			<!-- Encabezado de la sección de unidades con filtros y acciones -->
			<div class="units-header-panel">
				<!-- Fila principal con título y acciones -->
				<div class="units-header-row units-header-row-main">
					<!-- Bloque izquierdo con el título -->
					<div class="units-header-left">
						<span class="units-title">
							Lista de Unidades
						</span>
					</div>

					<!-- Bloque derecho con filtros y botones -->
					<div class="units-header-right" *ngIf="isAdmin">
						<!-- Filtro por cliente -->
						<div class="units-filter-block units-filter-dropdown">
							<p-dropdown
								[options]="clientes"
								optionLabel="name"
								optionValue="id"
								[(ngModel)]="selectedClientId"
								(ngModelChange)="onClientChange()"
								styleClass="filter-dropdown"
								[filter]="true"
								placeholder="Selecciona un cliente"
							></p-dropdown>
						</div>

						<!-- Botón para limpiar filtro -->
						<button
							*ngIf="selectedClientId"
							type="button"
							class="btn btn-outline-secondary btn_clean action-btn"
							(click)="clearClientFilter()"
							title="Quitar filtro"
						>
							<i class="fa fa-times"></i>
						</button>

						<!-- Grupo de acciones -->
						<div class="units-actions-group">
							<button
								class="btn btn-primary action-btn"
								(click)="add()"
							>
								<i class="fa fa-plus-square"></i>
								Agregar Unidad
							</button>

							<button
								class="btn btn-primary action-btn"
								(click)="openModalClient()"
							>
								<i class="fa fa-file-word-o"></i>
								Generar reporte
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="card-body">
				<app-datatable [options]="dtConfig"></app-datatable>
			</div>
		</div>
	</div>
</div>
